import { useProductContractHandoff } from "@/api/services/admin/product-contract";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { MatchForm } from "@/features/match/components/MatchForm";
import { AppRoutes } from "@/routes/config";

import { Stack } from "@mui/material";
import { FC } from "react";
import { useRef } from "react";
import { Navigate } from "react-router-dom";
import { styled } from "@mui/system";

type TMatchCreatePageProps = {};

export const MatchCreatePage: FC<TMatchCreatePageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);
  const { canCreateMatch, isLoading } = useProductContractHandoff();

  if (isLoading) return <LoadingScreen />;
  if (!canCreateMatch) return <Navigate to={AppRoutes.duringContractList} replace />;

  return (
    <MatchWrapper gap={4}>
      <TopPage
        title="新規紹介会社の追加"
        description="新しい紹介会社の基本情報および契約情報を入力してシステムに登録します。登録後、顧客ユーザーの追加も必要です。"
        enablePageBack={false}
      />
      <MatchForm ref={formRef} />
    </MatchWrapper>
  );
};

const MatchWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
